import { render, staticRenderFns } from "./english-big-report.vue?vue&type=template&id=bcf8ae32&scoped=true&"
import script from "./english-big-report.vue?vue&type=script&lang=js&"
export * from "./english-big-report.vue?vue&type=script&lang=js&"
import style0 from "./english-big-report.vue?vue&type=style&index=0&id=bcf8ae32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf8ae32",
  null
  
)

export default component.exports